module.exports = __webpack_public_path__ + "img/434.976f856d.jpg";